var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 26,
    viewBox: "0 0 49 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 4C0.75 1.79086 2.54086 0 4.75 0H44.75C46.9591 0 48.75 1.79086 48.75 4V22C48.75 24.2091 46.9591 26 44.75 26H4.75C2.54086 26 0.75 24.2091 0.75 22V4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1175 5.92462H20.4424V20.0745H29.1175V5.92462Z",
    fill: "#FF5F00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3182 13C21.3188 10.2423 22.5804 7.63616 24.7431 5.92506C21.0534 3.02402 15.7537 3.44571 12.5691 6.89374C9.38452 10.3418 9.38452 15.6582 12.5691 19.1063C15.7537 22.5543 21.0534 22.976 24.7431 20.0749C22.5804 18.3638 21.3188 15.7578 21.3182 13Z",
    fill: "#EB001B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3185 12.9997C39.321 16.4431 37.3566 19.5854 34.26 21.0915C31.1634 22.5975 27.4786 22.2026 24.7715 20.0746C26.9347 18.3639 28.1965 15.7576 28.1965 12.9997C28.1965 10.2417 26.9347 7.63539 24.7715 5.92471C27.4786 3.79671 31.1634 3.40182 34.26 4.90785C37.3566 6.41388 39.321 9.55624 39.3185 12.9997Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.8729748bbf0dee9a35e8bc7ecb092a44.svg";
export { ForwardRef as ReactComponent };